import ajax from './index'
import apiEnv from './apiEnv'
/**
 * 角色相关
 */
// 角色详情菜单列表
export function roleDetail(data) {
  return ajax.post(`${apiEnv.api1}/api/ExamManage/ExamMenu`, data)
}

// 获取日期的属性
export function GetDayProperty(data) {
    return ajax.post(`${apiEnv.api4}/api/Holiday/GetDayProperty`, data)
}
// 设置日期
export function AddHoliday(data) {
    return ajax.post(`${apiEnv.api4}/api/Holiday/AddHoliday`, data)
}
// 移除日期
export function RemoveHoliday(data) {
    return ajax.post(`${apiEnv.api4}/api/Holiday/RemoveHoliday`, data)
}